// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b28be280","239":"63eaf011","488":"a8404de8","667":"b2a49607"}[chunkId] + ".chunk.js";
};